/**
 * Small pill showing a metric's green/yellow/red status.
 * Used on the client portal dashboard cards.
 */
const META = {
  green:   { color: "#22C55E", label: "ON TARGET" },
  yellow:  { color: "#EAB308", label: "WATCH" },
  red:     { color: "#EF4444", label: "OFF TARGET" },
  unknown: { color: "#6B7280", label: "—" },
};

export default function MetricStatusPill({ status, testId }) {
  const m = META[status] || META.unknown;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-1.5 py-0.5 text-[9px] uppercase tracking-widest font-bold border"
      style={{ color: m.color, borderColor: `${m.color}55`, backgroundColor: `${m.color}10` }}
      data-testid={testId}
    >
      <span className="inline-block size-1.5 rounded-full" style={{ backgroundColor: m.color }} />
      {m.label}
    </span>
  );
}
